var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#014935"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8686 6.78829C16.8175 5.73724 15.1134 5.73724 14.0624 6.78829L13.3156 7.53511C13.3136 7.53699 13.3117 7.53888 13.3098 7.54078C13.3079 7.54269 13.306 7.54461 13.3041 7.54653L6.16522 14.6855C6.05943 14.7912 6 14.9347 6 15.0843V18.0928C6 18.4043 6.25255 18.6569 6.56408 18.6569H9.57253C9.72213 18.6569 9.86561 18.5974 9.9714 18.4916L17.8686 10.5945C18.9196 9.54342 18.9196 7.83933 17.8686 6.78829ZM13.7087 8.73742L7.12817 15.318V17.5287H9.33888L15.9194 10.9481L13.7087 8.73742ZM16.7172 10.1504L17.0708 9.79673C17.6813 9.18626 17.6813 8.19649 17.0708 7.58602C16.4604 6.97555 15.4706 6.97555 14.8601 7.58602L14.5065 7.93969L16.7172 10.1504Z",
    fill: "#90D3BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/edit-pen-icon.6172831680ade54e5cebc1b38c5ce5f3.svg";
export { ForwardRef as ReactComponent };